import Rover from '@rover/globals/Rover';

export const isMobileBrowser = () => Rover.userAgent.isMobile;
export const isTouchCapable = () => Rover.userAgent.isTouchCapable;
export const isTablet = () => Rover.userAgent.isTablet;
const _isHoverable =
  window && window.matchMedia ? !window.matchMedia('(hover: none)').matches : false;
export const isHoverable = () => _isHoverable;

Rover.utils = Rover.utils || {};
Rover.utils.isMobileOrTablet = () => Rover.userAgent.isMobile || Rover.userAgent.isTablet;

Rover.utils.isAndroid = function() {
  return navigator.userAgent.match(/Android/i) !== null;
};

Rover.utils.isWindowsPhone = function() {
  return (
    navigator.userAgent.match(/Windows NT 6.2/i) !== null &&
    navigator.userAgent.match(/Touch/i) !== null
  );
};

Rover.utils.isKindle = function() {
  return (
    navigator.userAgent.match(/\bSilk\/(.*\bMobile Safari\b)?/) ||
    navigator.userAgent.match(/\bKF\w/) ||
    navigator.userAgent.match('Kindle Fire')
  );
};

Rover.utils.isiOS = function() {
  return navigator.userAgent.match(/iPhone|iPod/i) !== null || navigator.userAgent.match(/iPad/);
};

Rover.utils.isiOS9 = function() {
  const isiOS = Rover.utils.isiOS();
  if (isiOS) {
    let match = navigator.userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/),
      version = parseInt(match[1], 10);
    return version === 9;
  }
  return false;
};

Rover.utils.isMobileEmbedded = function() {
  return document.body.classList.contains('js-mobile-embedded');
};

Rover.utils.getSourceDescription = () => {
  let source = '';
  if (isMobileBrowser()) {
    if (Rover.utils.isMobileEmbedded()) {
      if (Rover.utils.isAndroid()) {
        source = 'android';
      } else if (Rover.utils.isiOS()) {
        source = 'ios';
      }
    } else {
      source = 'mobile_web';
    }
  } else {
    source = 'web';
  }
  return source;
};

export default {
  isMobileBrowser,
  isTouchCapable,
  isTablet,
};



// WEBPACK FOOTER //
// ../utilities/device.js